import React, { FC, useState } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import TableTab from "../tabs/table-tab";
import { WizardStepLayout } from '../wizard/wizard-summary-layout';
import { getFilterTypes, NameOnlyColumn } from "./filterModalUtil";

interface TypeStepProps {
    onNext: (event: any) => void;
    menuId: string | undefined;
}

export const TypeStep: FC<TypeStepProps> = ({ onNext, menuId }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.selectAFilterType);
    const [enableNext, setEnableNext] = useState<boolean>(false);

    const onRowClicked = (rowData: any) => {
        const fakeOnclickEvent = {} as React.MouseEvent<HTMLButtonElement, MouseEvent>;
        const eventWithData = { ...fakeOnclickEvent, elementSysname: rowData.elementSysname, name: rowData.nameOriginal };
        setEnableNext(true);
        onNext(eventWithData);
    }

    return <WizardStepLayout onNext={onNext} nextDisabled={!enableNext}>
        <div className="overflow-y-auto" style={{ height: '87%' }}>
            <TableContextProvider
                usePagination
                useTable
                dataMethod={() => getFilterTypes(translate, menuId)}
                tableDescriptor={NameOnlyColumn}
                disableSearch={true}>
                <TableTab
                    title={title}
                    tableHeight="100%"
                    selectRows={false}
                    onRowClicked={(data) => onRowClicked(data)}
                    tableId={'filterType'}
                    cyName="filterType" />
            </TableContextProvider>
        </div>
    </WizardStepLayout>
}


